"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROGRAM_VERSION = exports.PROGRAM_VERSION_V2 = exports.PROGRAM_VERSION_V1 = void 0;
exports.PROGRAM_VERSION_V1 = 1;
exports.PROGRAM_VERSION_V2 = 2;
// The most up to date program version
exports.PROGRAM_VERSION = exports.PROGRAM_VERSION_V2;
//# sourceMappingURL=constants.js.map